import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import SettingAuthsService from "services/SettingAuthsService";

export const getAuthListApi = createAsyncThunk(
  "setting/auth/getAuthListApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SettingAuthsService.getAuthListApi();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateAuthSettingApi = createAsyncThunk(
  "setting/auth/updateAuthSettingApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingAuthsService.updateAuthSettingApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  authList: [],
};
export const settingAuthsSlice = createSlice({
  name: "setting-auth",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuthListApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAuthListApi.fulfilled, (state, action) => {
        state.loading = false;
        state.authList = action.payload;
      })
      .addCase(getAuthListApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateAuthSettingApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAuthSettingApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateAuthSettingApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = settingAuthsSlice.actions;

export default settingAuthsSlice.reducer;
